import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { ResultModel } from 'src/app/core/models/response/base.model';

@Injectable({
  providedIn: 'root'
})
export class UserMenuService {

  constructor(private apiService: ApiService) { }

  fetchMenu(reqModel): Observable<ResultModel> {
    const route = '/guest/menuFetch';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  fetchManageBrand(reqModel): Observable<ResultModel> {
    const route = '/guest/fetchManageBrand';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

}
